import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 3.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M10 18a8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8 8 8 0 0 0 8 8m-1.25-5.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h2.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75H11V9.75a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h.75v2zM10 8a.999.999 0 1 0 0-2 .999.999 0 1 0 0 2" })
});
export default SvgInfoCircleRegularIcon;
